<div class="messagesIcon" mat-dialog-title fxLayoutAlign="end center">
  <img src="assets/images/banner/red-close-icon.png" alt="Close icon" (click)="cancel()">
</div>
<mat-dialog-content class="messageContainer" [ngClass]="data.cssClass">
  @if (data.messages.length === 1) {
    <div class="confirmation-content" fxLayout="row" fxLayoutAlign="center center"
      [innerHTML]="data.messages[0].content" (click)="copyMsg(data.messages[0])">
    </div>
  }
  @if (data.messages.length > 1) {
    <ul class="message-items">
      @for (msg of distinctMsg(data.messages); track msg) {
        <li class="message-item" (click)="copyMsg(msg)">
          <div class="message-text" [innerHTML]="msg.content"></div>
        </li>
      }
    </ul>
  }
</mat-dialog-content>
@if (data.confirmText || data.cancelText) {
  <mat-dialog-actions class="msg-banner-actions" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px"
    >
    @if (data.confirmText) {
      <button mat-raised-button color="primary" (click)="confirm()">
        {{ data.confirmText }}
      </button>
    }
    @if (data.cancelText) {
      <button mat-stroked-button color="primary" (click)="cancel()">
        {{ data.cancelText }}
      </button>
    }
  </mat-dialog-actions>
}